import {ComponentPropsWithoutRef, useEffect, useRef} from 'react';
import styled from 'styled-components';
import {ClearIconComponent} from '@/components/Icons';
import {palette} from '@/styles';

interface IProps extends ComponentPropsWithoutRef<'input'> {
  onClear?(): void;
}

export const SearchInput = ({onClear, ...props}: IProps) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <Root>
      <TextField
        ref={ref}
        type="text"
        placeholder="지역 검색"
        autoComplete="off"
        {...props}
      />
      {!!props.value && !!onClear && (
        <ResetIcon color={palette.gray300} onClick={onClear} />
      )}
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${palette.gray150};
  padding: 0 12px;
  min-width: 0;
  height: 41px;
  color: ${palette.black};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.408px;
  flex-grow: 1;
`;

const TextField = styled.input`
  border: 0;
  flex-grow: 1;
  flex-basis: 0;
  min-width: 0;
  padding: 0;
  ::placeholder {
    color: ${palette.gray500};
  }
  color: ${palette.black};
`;

const ResetIcon = styled(ClearIconComponent)`
  display: block;
  width: 24px;
  height: 24px;
  cursor: pointer;
  flex-shrink: 0;
`;
